<nav aria-label="breadcrumb" *ngIf="isAddProject">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <li
      class="breadcrumb-item active"
      aria-current="page"
      *ngIf="currentProject"
    >
      {{ currentProject.name }}
    </li>
  </ol>
</nav>

<div *ngIf="isLoading" class="loaderdata">
  <div class="spinner-border" role="status">
    <span class="sr-only">{{ "Form.Loading" | translate }}</span>
  </div>
</div>
<div
  class="card main-card col-md-10 col-xl-8 mx-auto my-5 mb-3"
  *ngIf="currentProject"
>
  <div class="card-header d-flex justify-content-between align-items-center">
    <span>{{ currentProject.name }}</span>
    <div *ngIf="projectManagementId">
      <button
        style="padding: 3px; float: right; margin-left: 10px"
        type="button"
        id="btn-secret-key"
        placement="top"
        ngbTooltip="{{ 'Form.SECRET_KEY_BUTTON_Tooltip' | translate }}"
        class="btn-shadow btn btn-success font-size-lg px-3 py-2"
        (click)="findSecretKey()"
      >
        {{ "Form.SECRET_KEY_BUTTON" | translate }}
      </button>
    </div>
  </div>
  <div class="card-body">
    <form [formGroup]="form" class="needs-validation">
      <div class="position-relative row form-group">
        <label
          for="name_Id"
          id="project-name-label"
          class="col-sm-12 col-form-label"
          >{{ "Form.NAME" | translate }}
          <span class="text-danger">*</span></label
        >
        <div class="col-sm-12">
          <input
            formControlName="name"
            name="name"
            id="name_Id"
            placeholder="{{ 'Form.Placeholder.PROJECT_NAME' | translate }}"
            type="text"
            class="form-control"
            required
          />
          <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
            <div *ngIf="f.name.errors.required">
              {{ "Form.Error.NAME" | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="position-relative row form-group">
        <label
          for="desc_Id"
          class="col-sm-12 col-form-label"
          id="description-label"
          >{{ "Form.DESCRIPTION" | translate }}</label
        >
        <div class="col-sm-12">
          <textarea
            formControlName="description"
            name="description"
            id="desc_Id"
            placeholder="{{ 'Form.DESCRIPTION' | translate }}"
            type="text"
            class="form-control"
          ></textarea>
        </div>
      </div>

      <fieldset id="envUrls">
        <div
          class="position-relative row form-group"
          [ngClass]="{ 'border-error': matchingField.includes('liveUrl') }"
        >
          <label for="live_url_id" class="col-sm-12 col-form-label"
            >{{ "Form.STATUS_OF_LIVE" | translate }}
            <span class="text-danger">*</span>
          </label>
          <div class="col-sm-12">
            <input
              formControlName="liveUrl"
              name="liveUrl"
              id="live_url_id"
              placeholder="{{ 'Form.Placeholder.STATUS_OF_LIVE' | translate }}"
              type="text"
              class="form-control"
              required
            />
            <div *ngIf="submitted && f.liveUrl.errors" class="invalid-feedback">
              <div *ngIf="f.liveUrl.errors.required">
                {{ "Form.Error.STATUS_OF_LIVE" | translate }}
              </div>
              <div
                *ngIf="!f.liveUrl.errors.required && liveUrlErrors"
                class="text-danger"
              >
                {{ "Form.Error.liveUrlErrors" | translate }}
              </div>
              <div
                *ngIf="!liveUrlErrors && !f.liveUrl.errors.required"
                class="text-danger"
              >
                {{ "Form.Error.UrlInvalid" | translate }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="position-relative row form-group"
          [ngClass]="{ 'border-error': matchingField.includes('testUrl') }"
        >
          <label for="test_url_id" class="col-sm-12 col-form-label"
            >{{ "Form.STATUS_OF_TEST" | translate }}
            <span class="text-danger">*</span></label
          >
          <div class="col-sm-12">
            <input
              formControlName="testUrl"
              name="testUrl"
              id="test_url_id"
              placeholder="{{ 'Form.Placeholder.STATUS_OF_TEST' | translate }}"
              type="text"
              class="form-control"
              required
            />
            <div *ngIf="submitted && f.testUrl.errors" class="invalid-feedback">
              <div *ngIf="f.testUrl.errors.required">
                {{ "Form.Error.STATUS_OF_TEST" | translate }}
              </div>
              <div
                *ngIf="!f.testUrl.errors.required && testUrlErrors"
                class="text-danger"
              >
                {{ "Form.Error.testUrlErrors" | translate }}
              </div>
              <div
                *ngIf="!testUrlErrors && !f.testUrl.errors.required"
                class="text-danger"
              >
                {{ "Form.Error.UrlInvalid" | translate }}
              </div>
            </div>
          </div>
        </div>

        <div
          class="position-relative row form-group"
          [ngClass]="{ 'border-error': matchingField.includes('devUrl') }"
        >
          <label for="dev_url_id" class="col-sm-12 col-form-label"
            >{{ "Form.STATUS_OF_DEV" | translate }}
          </label>
          <div class="col-sm-12">
            <input
              formControlName="devUrl"
              name="devUrl"
              id="dev_url_id"
              placeholder="{{ 'Form.Placeholder.STATUS_OF_DEV' | translate }}"
              type="text"
              class="form-control"
            />
            <div *ngIf="submitted && f.devUrl.errors" class="invalid-feedback">
              <div *ngIf="devUrlErrors && f.devUrl.touched" class="text-danger">
                {{ "Form.Error.devUrlErrors" | translate }}
              </div>
              <div
                *ngIf="!devUrlErrors && f.devUrl.touched"
                class="text-danger"
              >
                {{ "Form.Error.UrlInvalid" | translate }}
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <div class="position-relative row form-group">
        <label for="project_status_id" class="col-sm-12 col-form-label">{{
          "Form.STATUS" | translate
        }}</label>
        <mat-slide-toggle
          [(ngModel)]="state"
          [ngModelOptions]="{ standalone: true }"
          (change)="onChange($event)"
          class="custom-slide-toggle"
        >
          {{
            state ? ("Form.ENABLE" | translate) : ("Form.DISABLE" | translate)
          }}
        </mat-slide-toggle>
        <!--    <div class="col-sm-12">
          <div class="form-group form-row">
          
            <div class="custom-radio mt-2 mb-0 pb-0 custom-control">
              <input
                class="custom-control-input"
                id="disabled"
                name="status"
                type="radio"
                value="disabled"
                formControlName="status"
              />
              <label class="custom-control-label">{{
                "Form.DISABLE" | translate
              }}</label>
            </div>

            <div class="custom-radio custom-control">
              <input
                class="custom-control-input"
                id="enable"
                name="status"
                type="radio"
                value="enable"
                formControlName="status"
                checked
              />
              <label class="custom-control-label">{{
                "Form.ENABLE" | translate
              }}</label>
            </div>
          </div>
        </div> -->
      </div>

      <div class="position-relative row form-group project-lang">
        <label for="primary_language_id" class="col-sm-12 col-form-label">{{
          "Form.PRIMARY_LANGUAGE" | translate
        }}</label>
        <div class="col-sm-12">
          <ng-select
            [items]="languageList"
            [virtualScroll]="true"
            bindLabel="name"
            bindValue="id"
            placeholder="{{ 'Form.SELECT_LANGUAGE' | translate }}"
            [(ngModel)]="primaryLanguage"
            (ngModelChange)="markFormDirty()"
            [ngModelOptions]="{ standalone: true }"
          >
          </ng-select>
        </div>
      </div>
      <div class="position-relative row form-group supported-lang">
        <label for="primary_language_id" class="col-sm-12 col-form-label">{{
          "Form.SUPPORTED_LANGUAGE" | translate
        }}</label>
        <div class="col-sm-12">
          <ng-select
            [items]="languageList"
            (ngModelChange)="markFormDirty()"
            [virtualScroll]="true"
            bindLabel="name"
            [multiple]="true"
            placeholder="{{ 'Form.SELECT_LANGUAGE' | translate }}"
            [(ngModel)]="selectedSupportedLanguages"
            [ngModelOptions]="{ standalone: true }"
            [closeOnSelect]="false"
          >
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="ng-value" *ngFor="let item of items | slice : 0 : 4">
                <span class="ng-value-label">{{ item.name }}</span>
                <span
                  class="ng-value-icon right"
                  (click)="clear(item)"
                  aria-hidden="true"
                  >×</span
                >
              </div>
              <div class="ng-value" *ngIf="items.length > 4">
                <span class="ng-value-label">
                  + {{ items.length - 4 }} {{ "Form.more" | translate }}</span
                >
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div>
        <div
          class="d-flex justify-content-start pl-0"
          style="padding-top: 1rem; padding-right: 1rem"
        >
          <button
            class="btn btn-primary btn-lg font-size-lg mt-2 pt-2 px-5"
            style="margin-right: 10px"
            type="submit"
            (click)="onSubmit()"
            id="submitBtn"
          >
            {{ "Form.SAVE" | translate }}
          </button>
          <button
            class="btn btn-secondary btn-lg mt-2 pt-2 px-5 text-white"
            (click)="onProjectReset()"
          >
            {{ "Form.CANCEL" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
